import { db } from './db'
import type { ImportedCity } from '$lib/types'

export type NewImportedCity = Omit<ImportedCity, 'id'>

export async function add(record: NewImportedCity): Promise<number> {
  return db.imports.add(record as ImportedCity)
}

export async function get(id: number): Promise<ImportedCity | undefined> {
  return db.imports.get(id)
}

export async function list(): Promise<ImportedCity[]> {
  return db.imports.orderBy('importedAt').reverse().toArray()
}

export async function rename(id: number, name: string): Promise<void> {
  await db.imports.update(id, { name })
}

export async function remove(id: number): Promise<void> {
  await db.imports.delete(id)
}
